// components/OidcCallback.jsx
import React, { useEffect } from 'react';
import { useAuth as useOidcAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

export default function OidcCallback() {
  const auth = useOidcAuth();
  const nav = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        // react-oidc-context will parse ?code & exchange for tokens
        await auth.signinRedirectCallback();
      } catch (e) {
        console.error('[OIDC] callback error:', e);
      } finally {
        // go to your app root after processing
        nav('/', { replace: true });
      }
    })();
  }, [auth, nav]);

  return (
    <div style={{minHeight:'100vh', display:'grid', placeItems:'center'}}>
      <div>Finishing sign-in…</div>
    </div>
  );
}
